// Thin wrapper over Telegram.WebApp.platform. Centralized so per-platform
// workarounds (storage, confirm, etc.) read from one source of truth.
export function getPlatform() {
	return window.Telegram?.WebApp?.platform || "unknown";
}

// Web clients (both weba and webk) plus unknown run inside a browser iframe.
// showConfirm is broken there because the miniapp window itself counts as a
// popup and nested popups aren't supported. Use these to decide whether to
// fall back to native window.confirm.
export const webPlatforms = ["web", "weba", "webk", "unknown"];

export function isWebPlatform() {
	return webPlatforms.includes(getPlatform());
}